/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CardType = {
    properties: {
        translation: {
            type: 'Translation',
            isRequired: true,
        },
        key: {
            type: 'CardTypeEnum',
            isRequired: true,
        },
    },
} as const;
